import { render, staticRenderFns } from "./AdminEventhub.vue?vue&type=template&id=ac9dd43e&"
import script from "./AdminEventhub.vue?vue&type=script&lang=js&"
export * from "./AdminEventhub.vue?vue&type=script&lang=js&"
import style0 from "./AdminEventhub.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
